<template>
  <LayoutBase :isHideHeader="true">
    <div class="block-cover">
      <div class="quiz-content-box">
        <!-- <div class="quiz-resul-img"><img :src="result.img" alt="" /></div> -->

        <div class="quiz-content-result">
          <div class="quiz-content-text">
            <p class="defalt-quiz-paragraf">{{ result.titleSmall }}</p>

            <p class="quiz-title-result" v-if="result.title">
              {{ result.title }}
            </p>

            <p class="quiz-paragraf-resul">{{ result.text }}</p>
            <p class="quiz-paragraf-resul">{{ result.text2 }}</p>
          </div>

            <SWButton id="btn-try-free" class="quiz-btn-resul-one" variant="primari" size="big" fullWidth @click="goRegistration">
              {{ result.button }}
            </SWButton>

          <SWButton class="quiz-btn-resul-two" variant="secondary" size="big" fullWidth @click="isShare = !isShare">
            Share my result
          </SWButton>
            <transition name="fade">
               <div v-if="isShare" class="share-buttons">
                  <button @click="shareOnFacebook" id="shareBtn" class="share__item">
                     <ResultsShareItem :iconName="'facebookShare.svg'" :name="'facebook'" />
                  </button>
                  <a
                     class="share__item"
                     target="_blank"
                     :href="`https://twitter.com/intent/tweet?text=I completed the Sleep Coach test, and here's my result: ${result.textContent}. 
               Curious about your sleep? Fill out a quick test at sleep-well.coach to learn more about it! link: https://sleep-well.coach`"
                  >
                     <ResultsShareItem :iconName="'icons8-x.svg'" :name="'x'" />
                  </a>
               </div>
            </transition>
        </div>
      </div>
    </div>
  </LayoutBase>
</template>

<script>
import LayoutBase from '../components/layouts/LayoutBase.vue';
import { SWButton } from 'sw-ui-kit';
import ResultsShareItem from '../components/ResultsComponents/ResultShareItem.vue';

const RESULTS = [
  {
    id: 1,
    titleSmall: 'Your Sleep Profile',
    title: 'Stress-Driven Sleep Depletion',
    text:
      'Your answers suggest that stress and mental overload are preventing your body from fully recovering at night. Even if you sleep enough hours, your nervous system stays active, leaving you tired and unfocused during the day.',
    text2:
      'Based on your profile, we’ve prepared personalized recommendations to help you restore deep, restorative sleep.',
    button: 'Get my personalized plan',
    // img: require('../assets/img/ImageQresult1.png'),
  },
  {
    id: 2,
    titleSmall: 'Your Result',
    title: 'Low Sleep Recovery Score',
    text:
      'Your sleep isn’t giving you the recovery your body and brain need. This often leads to low energy, brain fog, and reduced focus throughout the day.',
    text2:
      'We’ve created step-by-step recommendations based on your answers to help improve your sleep quality.',
    button: 'See my recommendations',
    // img: require('../assets/img/ImageQresult2.png'),
  },
  {
    id: 3,
    titleSmall: 'Your Sleep Type',
    title: 'Fragmented & Non-Restorative Sleep',
    text:
      'You’re getting sleep, but not enough quality recovery. Nighttime interruptions and daytime fatigue point to a disrupted sleep rhythm.',
    text2:
      'Discover what’s causing this pattern and what to adjust first for noticeable improvement.',
    button: 'Unlock my sleep insights',
    // img: require('../assets/img/ImageQresult3.png'),
  },
  {
    id: 4,
    titleSmall: 'Your Personalized Insight',
    title: '',
    text:
      'Your responses indicate that your main challenge isn’t sleep duration — it’s sleep quality. This can quietly drain your energy, mood, and productivity.',
    text2:
      'The good news: this pattern is fixable with the right approach.',
    button: 'Get my personalized recommendations',
    // img: require('../assets/img/ImageQresult1.png'),
  },
  {
    id: 5,
    titleSmall: 'Your Sleep Assessment Is Complete',
    title: '',
    text:
      'Based on your answers, your body isn’t fully recharging during sleep, which explains the fatigue and lack of clarity you’re experiencing.',
    text2:
      'We’ve prepared tailored guidance to help you improve your sleep and feel better during the day.',
    button: 'Start my free sleep plan',
    // img: require('../assets/img/ImageQresult2.png'),
  },
];

function calcScores(a) {
  const scores = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

  const q1 = a[1], q2 = a[2], q3 = a[3], q4 = a[4], q5 = a[5];

  // Q1: morning feeling
  // (add some support for fragmented when user is tired/exhausted)
  if (q1 === 0) scores[5] += 2;
  if (q1 === 1) { scores[2] += 2; scores[4] += 1; }
  if (q1 === 2) { scores[4] += 2; scores[2] += 1; scores[3] += 1; } // +3
  if (q1 === 3) { scores[2] += 2; scores[1] += 1; scores[3] += 1; } // +3

  // Q2: sleep pattern (main driver for #3)
  if (q2 === 0) { scores[4] += 2; scores[2] += 1; }
  if (q2 === 1) { scores[3] += 4; }                // was 3
  if (q2 === 2) { scores[1] += 3; }
  if (q2 === 3) { scores[3] += 4; scores[1] += 1; } // was 2 (+1)

  // Q3: interference
  if (q3 === 0) scores[1] += 3;                      // stress/anxiety
  if (q3 === 1) scores[4] += 3;                      // schedule/screens
  if (q3 === 2) { scores[3] += 2; scores[2] += 2; }  // physical restlessness -> fragmented + low recovery
  if (q3 === 3) scores[5] += 3;

  // Q4: typical day
  if (q4 === 0) scores[2] += 3;                      // caffeine reliance
  if (q4 === 1) { scores[2] += 2; scores[3] += 1; }  // afternoon crash can correlate with fragmented
  if (q4 === 2) { scores[1] += 2; scores[2] += 1; }
  if (q4 === 3) scores[4] += 3;

  // Q5: goal (light weighting; don't overpower)
  if (q5 === 0) scores[2] += 1;
  if (q5 === 1) scores[2] += 1;
  if (q5 === 2) scores[1] += 1;
  if (q5 === 3) scores[5] += 1;

  return scores;
}

function pickResultId(scores) {
  const entries = Object.entries(scores).map(([k, v]) => [Number(k), v]);
  entries.sort((a, b) => b[1] - a[1]);

  const bestScore = entries[0][1];

  // If signal is weak -> #5
  if (bestScore <= 2) return 5;

  // If tie: pick by priority (so every result can win)
  const tied = entries.filter(([, v]) => v === bestScore).map(([k]) => k);

  // Priority: 1 (stress), 3 (fragmented), 2 (recovery), 4 (quality), 5 (generic)
  const priority = [1, 3, 2, 4, 5];

  for (const id of priority) {
    if (tied.includes(id)) return id;
  }

  return entries[0][0];
}

export default {
  components: { LayoutBase, SWButton, ResultsShareItem},
  data() {
    return { isShare: false , dlCtaSent: false, };
  },
  mounted() {
    this.loadFacebookSDK();
  },
  computed: {
    result() {
      const answers = this.$route.params?.answers || {};
      const a = {};
      Object.keys(answers).forEach(k => {
        a[Number(k)] = Number(answers[k]);
      });

      const scores = calcScores(a);
      const id = pickResultId(scores);

      return RESULTS.find(r => r.id === id) || RESULTS.find(r => r.id === 5);
    },
  },

  methods: {
    goRegistration() {
      if (this.dlCtaSent) return;
      this.dlCtaSent = true;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'quiz_complete_cta_click',
          button_name: 'try_it_for_free',
          button_location: 'quiz_final_screen',
          page_url: window.location.href,
        });
      } catch (e) {
        console.warn( 'dataLayer quiz button error', e );
      }
      localStorage.setItem('quiz2_allow_registration', 'true');
      this.$router.push({ name: 'registration' });
    },

      loadFacebookSDK() {
         return new Promise(resolve => {
            window.fbAsyncInit = function () {
               // eslint-disable-next-line
               FB.init({
                  appId: '1480226269391198',
                  autoLogAppEvents: true,
                  xfbml: true,
                  version: 'v17.0', // Use the latest version
               });
               resolve(); // Resolve the promise when SDK is initialized
            };

            // Load the Facebook SDK script
            (function (d, s, id) {
               var js,
                  fjs = d.getElementsByTagName(s)[0];
               if (d.getElementById(id)) return;
               js = d.createElement(s);
               js.id = id;
               js.src = 'https://connect.facebook.net/en_US/sdk.js';
               fjs.parentNode.insertBefore(js, fjs);
            })(document, 'script', 'facebook-jssdk');
         });
      },
      shareOnFacebook() {
         // eslint-disable-next-line
         FB.ui({
            method: 'share',
            href: 'https://sleep-well.coach',
            quote: `I got this advice: ${this.result.textContentTwo}`,
         });
      },
   },
};
// res1
// Q1 → Exhausted and struggling to get out of bed
// Q2 → I struggle to fall asleep
// Q3 → Stress or anxiety that keeps my mind active
// Q4 → I feel mentally foggy and easily irritated
// Q5 → Feeling calmer, more emotionally balanced, and less reactive
// res2
// Q1 → Awake, but low on energy
// Q2 → I fall asleep easily and sleep through the night
// Q3 → Physical discomfort or restlessness at night
// Q4 → I rely on caffeine to stay focused
// Q5 → Better focus, memory, and productivity during the day
// res3
// Q1 → Tired, even after a full night of sleep
// Q2 → I fall asleep easily, but wake up during the night
// Q3 → Physical discomfort or restlessness at night
// Q4 → My energy drops sharply in the afternoon
// Q5 → Understanding the real cause of my sleep issues
// res4
// Q1 → Tired, even after a full night of sleep
// Q2 → I fall asleep easily and sleep through the night
// Q3 → Irregular schedule or late screen time
// Q4 → My energy feels stable, but sleep doesn’t feel restorative
// Q5 → Waking up with steady energy and mental clarity
// res5
// Q1 → Refreshed
// Q2 → Sleep through the night
// Q3 → I’m not sure
// Q4 → Energy feels stable
// Q5 → anyway
</script>
<style lang="sass" scoped>
@import '../sass/_variables'

.quiz-content-box
	display: flex
	width: 100%
	height: 100%
	justify-content: center
	align-items: center
	@media screen and (max-width:889px)
		flex-direction: column
		justify-content: center
		align-items: center

.quiz-title-result
	font-size: 32px
	font-weight: 700
	line-height: 41.6px
	text-align: center
	margin-bottom: 32px
.quiz-paragraf-resul
	font-size: 20px
	font-weight: 400
	line-height: 26px
	text-align: center
	margin-bottom: 40px
	@media screen and (max-width:380px)
		margin-bottom: 27px
.block-cover
	width: 100%
	@media screen and (max-width:880px)
		height: 100%
.defalt-quiz-paragraf
	margin-bottom: 32px
	text-align: center
	font-size: 16px
	font-weight: 400
	line-height: 20.8px
.quiz-btn-resul-one
	margin-bottom: 20px
.quiz-resul-img
	max-width: 730px
	width: 100%
	@media screen and (max-width:889px)
		max-width: 550px
	@media screen and (max-width:593px)
		max-width: 450px
.quiz-resul-img img
	@media screen and (max-width:889px)
		margin-bottom: 29.66px
.quiz-content-result
	max-width: 439px
	width: 100%
	margin-right: 60px
	margin-left: 20px
	@media screen and (max-width:889px)
		margin-right: 0
		margin-left: 0

.share-buttons
	margin-top: 20px
	display: flex
	align-items: center
	justify-content: center
	& > *:first-child
		margin-right: 10px
</style>

